// extracted by mini-css-extract-plugin
module.exports = {"browser-block":"browser-block___KHULr","not-support":"not-support___2a2me","browser-img":"browser-img___sb_Kg","browser-desc":"browser-desc___2EcSi","desc":"desc___AbC81"};